import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { ListCategoriesComponent } from 'app/modules/categories/list-categories/list-categories.component';
import { ListProductsComponent } from 'app/modules/products/list-products/list-products.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: () => localStorage.getItem('homeUrl') ?? 'sign-in' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: () => localStorage.getItem('homeUrl') ?? '/dashboard' },

    //! Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
            { path: 'check-t', loadChildren: () => import('app/modules/auth/check-t/check-t.routes') }
        ]
    },
    //! Commom auth routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        children: [
            { path: 'settings', loadChildren: () => import('app/modules/settings/settings.routes') },
        ]
    },
    //! Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
        ]
    },
    //! Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'users', loadChildren: () => import('app/modules/user/misc/user.routes') },
            { path: 'audit', loadChildren: () => import('app/modules/audit/audit.routes') },
            { path: 'usersBackoffice', loadChildren: () => import('app/modules/ok-admin/misc/ok-admin.routes') },
            { path: 'categories', component: ListCategoriesComponent },
            { path: 'products', component: ListProductsComponent },
            { path: 'push-notifications', loadComponent: () => import('app/modules/push-notifications/list-push-notifications/list-push-notifications.component').then(m => m.ListPushNotificationsComponent) },
            { path: 'dashboard', loadChildren: () => import('app/modules/dashboard/dashboard.routes') },
            { path: 'chat', loadChildren: () => import('app/modules/chat/chat.routes') },
            { path: 'announcements', loadChildren: () => import('app/modules/announcement/announcement.routes') },
            { path: 'pending', loadChildren: () => import('app/modules/announcement/in-approval.routes') },
            { path: 'campaign-stories', loadChildren: () => import('app/modules/campaign-stories/campaign-stories.routes') },
            { path: 'featured-ads-config', loadChildren: () => import('app/modules/featured-ads/featured-ads.routes') },
            { path: 'verification-config', loadChildren: () => import('app/modules/verification-config/verification-config.routes') },
            { path: 'settings/human-support', loadChildren: () => import('app/modules/settings/human-support/human-support.routes') },
            { path: 'human-support-config', loadChildren: () => import('app/modules/settings/human-support/human-support.routes') },
        ]
    }
];
